import { useFadeIn } from './useFadeIn';

export default function Contact() {
  const leftRef = useFadeIn();
  const rightRef = useFadeIn();

  return (
    <>
      <section id="contact" data-testid="footer-section" className="contact-section">
        <div className="contact-inner">
          <div className="contact-grid">
            {/* Left */}
            <div ref={leftRef} className="contact-left fade-up" data-testid="footer-contact">
              <p className="sec-overline">Get in touch</p>
              <h2 className="sec-title">Let's make your<br />brand unforgettable.</h2>
              <p className="contact-tagline">
                Whether you're launching a campaign, scaling an existing strategy, or exploring influencer marketing for the first time — we'd love to hear from you.
              </p>
              <div className="contact-details">
                <a
                  href="mailto:hello@talkingtalent.in"
                  className="contact-row"
                  data-testid="contact-email"
                >
                  <span className="contact-icon">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <rect x="1" y="3" width="14" height="10" rx="1.5" stroke="#000" strokeWidth="1.2"/>
                      <path d="M1 5l7 5 7-5" stroke="#000" strokeWidth="1.2" strokeLinecap="round"/>
                    </svg>
                  </span>
                  hello@talkingtalent.in
                </a>
                <a
                  href="tel:+918082665284"
                  className="contact-row"
                  data-testid="contact-phone"
                >
                  <span className="contact-icon">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M5.5 1.5c-.5 0-1 .5-1.5 1.5S3 6 5.5 8.5 10 13 11 12.5s1.5-1 1.5-1.5-1-1.5-1.5-2-1 0-1.5.5C9 10 7 8 6.5 7.5c-.5-.5 0-1 .5-1.5s.5-1 0-1.5L5.5 1.5z" stroke="#000" strokeWidth="1.2" strokeLinecap="round"/>
                    </svg>
                  </span>
                  +91 80826 65284
                </a>
              </div>
            </div>

            {/* Right — socials */}
            <div ref={rightRef} className="contact-right fade-up" data-testid="footer-nav">
              <p className="sec-overline">Follow us</p>
              <div className="contact-socials">
                <a
                  href="https://instagram.com/talkingtalent_"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-social-link"
                  data-testid="contact-instagram"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect x="2" y="2" width="20" height="20" rx="5" stroke="#000" strokeWidth="1.4"/>
                    <circle cx="12" cy="12" r="4.5" stroke="#000" strokeWidth="1.4"/>
                    <circle cx="17.5" cy="6.5" r="1" fill="#000"/>
                  </svg>
                  <div>
                    <div className="contact-social-name">Instagram</div>
                    <div className="contact-social-handle">@talkingtalent_</div>
                  </div>
                </a>
                <a
                  href="https://www.linkedin.com/company/talking-talentt/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-social-link"
                  data-testid="contact-linkedin"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect x="2" y="2" width="20" height="20" rx="4" stroke="#000" strokeWidth="1.4"/>
                    <path d="M7 10v7M7 7v.5" stroke="#000" strokeWidth="1.5" strokeLinecap="round"/>
                    <path d="M11 17v-4c0-1.5 1-2.5 2.5-2.5S16 11.5 16 13v4" stroke="#000" strokeWidth="1.4" strokeLinecap="round"/>
                    <path d="M11 10v7" stroke="#000" strokeWidth="1.4" strokeLinecap="round"/>
                  </svg>
                  <div>
                    <div className="contact-social-name">LinkedIn</div>
                    <div className="contact-social-handle">talking-talentt</div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Footer strip */}
        <div className="footer-strip">
          <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 2rem', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem' }}>
              <a href="#" aria-label="Talking Talent Home">
                <img
                  src="https://customer-assets.emergentagent.com/job_coaching-platform-59/artifacts/zi17ndy5_Talking%20Talent%20Logo-01.png"
                  alt="Talking Talent"
                  className="footer-logo-img"
                />
              </a>
              <span className="footer-legal">
                &copy; {new Date().getFullYear()} Talking Talent. All rights reserved.
              </span>
            </div>
            <nav className="footer-nav" data-testid="footer-nav">
              <a href="#about">About</a>
              <a href="#services">Services</a>
              <a href="#clients">Clients</a>
              <a href="#ourwork">Our Work</a>
              <a href="#contact">Contact</a>
            </nav>
          </div>
        </div>
      </section>
    </>
  );
}
